import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { inr, fmtDate } from "@/lib/api";

const WALLET_CLR = { collection: "bg-emerald-50 text-emerald-700", payout: "bg-blue-50 text-blue-700", chargeback: "bg-amber-50 text-amber-700" };
const STATUS_CLR = { pending: "bg-amber-50 text-amber-700", approved: "bg-emerald-50 text-emerald-700", rejected: "bg-rose-50 text-rose-700" };

export const Pill = ({ className, children, ...p }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${className}`} {...p}>{children}</span>
);

const Empty = ({ cols, text }) => (
  <TableRow><TableCell colSpan={cols} className="py-10 text-center text-sm text-slate-400">{text}</TableCell></TableRow>
);

export const TxTable = ({ rows, showUser = false }) => (
  <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="transactions-table">
    <Table>
      <TableHeader>
        <TableRow className="bg-slate-50">
          <TableHead>Date</TableHead>
          {showUser && <TableHead>Merchant</TableHead>}
          <TableHead>Wallet</TableHead>
          <TableHead>Description</TableHead>
          <TableHead>UTR</TableHead>
          <TableHead className="text-right">Amount</TableHead>
          <TableHead className="text-right">Balance</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && <Empty cols={showUser ? 7 : 6} text="No transactions yet" />}
        {rows.map((t) => (
          <TableRow key={t.id} data-testid={`txn-row-${t.id}`}>
            <TableCell className="whitespace-nowrap text-xs text-slate-500">{fmtDate(t.created_at)}</TableCell>
            {showUser && <TableCell className="whitespace-nowrap text-sm font-medium">{t.user_name}</TableCell>}
            <TableCell><Pill className={WALLET_CLR[t.wallet]}>{t.wallet}</Pill></TableCell>
            <TableCell className="min-w-[180px] text-sm text-slate-700">{t.note}</TableCell>
            <TableCell className="font-mono text-xs text-slate-600">{t.utr || "-"}</TableCell>
            <TableCell className={`whitespace-nowrap text-right font-semibold ${t.type === "credit" ? "text-emerald-600" : "text-rose-600"}`}>
              {t.type === "credit" ? "+" : "-"}{inr(t.amount)}
            </TableCell>
            <TableCell className="whitespace-nowrap text-right text-sm text-slate-500">{inr(t.balance_after)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

export const PayoutTable = ({ rows, showUser = false, onProcess }) => (
  <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="payouts-table">
    <Table>
      <TableHeader>
        <TableRow className="bg-slate-50">
          <TableHead>Date</TableHead>
          {showUser && <TableHead>Merchant</TableHead>}
          <TableHead>Beneficiary</TableHead>
          <TableHead>Account / IFSC</TableHead>
          <TableHead className="text-right">Amount</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>UTR</TableHead>
          {onProcess && <TableHead className="text-right">Action</TableHead>}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && <Empty cols={8} text="No payouts yet" />}
        {rows.map((p) => (
          <TableRow key={p.id} data-testid={`payout-row-${p.id}`}>
            <TableCell className="whitespace-nowrap text-xs text-slate-500">{fmtDate(p.created_at)}</TableCell>
            {showUser && (
              <TableCell className="whitespace-nowrap text-sm">
                <div className="font-medium">{p.user_name}</div>
                <div className="text-xs text-slate-400">{p.user_email}</div>
              </TableCell>
            )}
            <TableCell className="whitespace-nowrap text-sm font-medium">{p.holder_name}</TableCell>
            <TableCell className="whitespace-nowrap font-mono text-xs">
              <div>{p.account_number}</div>
              <div className="text-slate-400">{p.ifsc}</div>
            </TableCell>
            <TableCell className="whitespace-nowrap text-right font-semibold">{inr(p.amount)}</TableCell>
            <TableCell>
              <Pill className={STATUS_CLR[p.status]} data-testid={`payout-status-${p.id}`}>{p.status}</Pill>
              {p.remark && <div className="mt-1 max-w-[160px] text-xs text-slate-400">{p.remark}</div>}
            </TableCell>
            <TableCell className="font-mono text-xs">{p.utr || "-"}</TableCell>
            {onProcess && (
              <TableCell className="text-right">
                {p.status === "pending" ? (
                  <button
                    data-testid={`process-payout-btn-${p.id}`}
                    onClick={() => onProcess(p)}
                    className="rounded-md bg-[#2563EB] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#1D4ED8]"
                  >
                    Process
                  </button>
                ) : <span className="text-xs text-slate-400">Done</span>}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
